module.exports = __webpack_public_path__ + "img/ico-ko.93a03964.svg";